<template>
  <div class="progress-wrapper">
    <span class="progress-bar" ref="progress-bar" :style="{Width: progressPercent + '%'}"></span>

  </div>
</template>

<script>
export default {
  name: 'article-progress',
  data () {
    return {
      progressPercent: 33
    }
  },
  computed: {
    // progressPercent () {
    //   return 44
    // }
  },
  methods: {
    getProgress (str) {
      return ''
      // $(window).load(function(){
      //   $(window).scroll(function() {
      //     var wintop = $(window).scrollTop(), docheight = $('article').height(), winheight = $(window).height();
      //     console.log(wintop);
      //     var totalScroll = (wintop/(docheight-winheight))*100;
      //     console.log("total scroll" + totalScroll);
      //     $(".KW_progressBar").css("width",totalScroll+"%");
      //   });

      // });
    }
  }
}
</script>

<style lang='scss' scoped>
.progress-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;

  .progress-bar {
    display: block;
    // width: 72%; // TODO: update dynmically with scroll of doc height
    background-color: #197a72;
    height: 5px;
    width: 0;
  }

  .progress {
    background: linear-gradient(to right,var(--subtle-green1) var(--scroll),transparent 0);
    position: fixed;
    width: 100%;
    height: 4px;
    z-index: z('article-progress');
  }
}
</style>



// WEBPACK FOOTER //
// ArticleProgress.vue?429b5086